import { inputTypes } from 'components/common/FormElements/Input'
import { PASSWORD_HINT_ID } from 'constant'
import {
  PASSWORD_PROPERTY,
  EMAIL_PROPERTY,
  CONFIRM_PASSWORD_PROPERTY,
  KEEP_IN_CONTACT_PROPERTY,
  TERMS_AGREEMENT_PROPERTY,
  HIDDEN_PROPERTY,
  EMAIL_HINT_ID,
  FIRST_NAME_PROPERTY,
  LAST_NAME_PROPERTY,
  PHONE_NUMBER_PROPERTY
} from './constants'

export default {
  password: {
    name: PASSWORD_PROPERTY,
    label: 'Password',
    type: 'password',
    'aria-describedby': PASSWORD_HINT_ID,
    required: true
  },
  confirmPassword: {
    name: CONFIRM_PASSWORD_PROPERTY,
    label: 'Confirm Password',
    type: 'password',
    'aria-describedby': PASSWORD_HINT_ID,
    required: true
  },
  email: {
    name: EMAIL_PROPERTY,
    label: 'Email',
    type: 'email',
    'aria-describedby': EMAIL_HINT_ID,
    required: true
  },
  keepInContact: {
    name: KEEP_IN_CONTACT_PROPERTY,
    inputType: inputTypes.CHECKBOX_INPUT,
    value: true,
    'data-at-register-keepincontact': true
  },
  termsAgreement: {
    name: TERMS_AGREEMENT_PROPERTY,
    label: 'I understand and agree that registration on or use of this site constitutes acceptance of our',
    inputType: inputTypes.CHECKBOX_INPUT,
    linkLabel: 'Privacy Policy',
    'data-at-register-agree': true,
    required: true
  },
  hiddenField: {
    name: HIDDEN_PROPERTY,
    type: 'hidden'
  },
  firstName: {
    name: FIRST_NAME_PROPERTY,
    label: 'First Name',
    type: 'text',
    'data-at-register-firstname': true,
    required: true
  },
  lastName: {
    name: LAST_NAME_PROPERTY,
    label: 'Last Name',
    type: 'text',
    'data-at-register-lastname': true,
    required: true
  },
  primaryPhone: {
    name: PHONE_NUMBER_PROPERTY,
    label: 'Phone Number',
    type: 'text',
    'data-at-register-phonenumber': true,
    required: true
  }
}
